<template>
	<section>
		<div v-if="showParentView('page-user')">
			<header-page
				name="users"
				:title="$route.meta.title"
			/>
			<users-list
				:code-project="codeProject"
				:columns="columns"
				:company-code="idCompany"
				:current-page="currentPage"
				:rows="table.rows"
				:last-page="table.lastPage"
				@change-page="changePage"
				@change-state="changeState"
				@on-search="onSearch($event, `project/${codeProject}/company/${idCompany}/users`)"
			/>
			<quick-actions
				:actions="actions"
				@open-modal="openModal"
			>
			</quick-actions>
		</div>
		<router-view></router-view>
	</section>
</template>

<script>
	import quickActions from '@/components/shared/quick-actions';
	import usersList from '@/components/users/users-list';

	function created() {
		if (this.$route.name === 'page-user') {
			this.loadData(`project/${this.codeProject}/company/${this.idCompany}/users`);
		}
	}

	function changePage(page) {
		this.params.page = page;
		this.currentPage = page;
		this.loadData(`project/${this.codeProject}/company/${this.idCompany}/users`);
	}

	async function changeState({ user, codeProject, codeCompany }) {
		const { codeUser, status } = user;
		const model = { codeProject, flagActive: status, codeCompany };
		try {
			await this.$http.patch(`users/${codeUser}`, model);
			this.showNotification('El estado del usuario se modificó correctamente.', 'success');
		} catch (err) {
			this.showError();
		} finally {
			this.loadData(`project/${this.codeProject}/company/${this.idCompany}/users`);
		}
	}
	
	function goToNew() {
		const codeProject = this.codeProject;
		const companyCode = this.idCompany;
		this.goTo('page-user-new', { params: { codeProject, companyCode } });
	}


	function openModal() {
		const codeProject = this.codeProject;
		const companyCode = this.idCompany;
		this.goTo('page-user-new', { params: { codeProject, companyCode } });
	}

	function data() {
		return {
			actions: [
				{
					id: 1,
					code: 'CP',
					text: 'Crear Usuario',
					icon: 'person_add',
					active: true,
				},
			],
			columns: [
				{ id: 1, name: 'Correo', checked: true, visible: true },
				{ id: 2, name: 'Codigo de Usuario', checked: true, visible: true },
				{ id: 3, name: 'Compañia', checked: true, visible: true },
				{ id: 4, name: 'Acciones', checked: true, visible: true, flagVisible: true },
			],
			currentPage: 1,
		};
	}

	export default {
		name: 'page-user',
		components: {
			usersList,
			quickActions,
		},
		created,
		data,
		methods: {
			changePage,
			changeState,
			goToNew,
			openModal,
		},
		props: {
			codeProject: {
				type: String,
			},
			idCompany: {
				type: String,
			},
		},
		watch: {
			$route(newVal) {
				if (newVal) {
					if (newVal.name === 'page-user') {
						this.loadData(`project/${this.codeProject}/company/${this.idCompany}/users`);
					}
				}
			},
		},
	};
</script>




// WEBPACK FOOTER //
// src/pages/users/page-user.vue